import React, { useState } from 'react';
import {
    Col,
    Form,
    FormControl,
    FormGroup,
    FormLabel,
} from 'react-bootstrap';
import {
    Card,
    InputPassword,
    LoaderBtn,
    Captcha,
    PhoneInput,
} from 'components';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { RegExpConst, mapAPIError } from '_helpers';
import { SendVerificationCode, IExpertConfirmationData } from '../../api/ApiClient';
import styles from './Step.module.scss';

const defaultState: IState = {
    password: '',
    captcha: '',
    token: '',
};

const Step1 = ({
    apiError, sendRegistrationVerificationCode, nextStep, expertData, checkAccountConfirmationToken, token,
}: Props) => {
    const [form, setForm] = useState(defaultState);
    const [errors, setErrors] = useState(defaultState);
    const [captcha, setCaptcha] = React.useState('');
    const [captchaValid, setCaptchaValid] = React.useState(true);
    const [processing, setProcessing] = useState(false);

    React.useEffect(() => {
        setErrors({
            ...errors,
            ...mapAPIError(apiError),
        });
    }, [apiError]);

    const doValidate = (formData: IState) => {
        const test = (field: string, regexp: RegExp) => (regexp.test(field) ? '' : 'Error');
        const validateErrors = { ...errors };
        validateErrors.password = test(formData.password, RegExpConst.PASSWORD);
        validateErrors.captcha = '';

        const isCaptchaValid = apiError && apiError.failures && apiError.failures.captcha ? captcha.length === 4 : true;
        const isFormValid = !validateErrors.password;

        setCaptchaValid(isCaptchaValid);
        setErrors(validateErrors);

        return isFormValid && isCaptchaValid;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (typeof value !== 'string' || !name) return;

        const newForm = {
            ...form,
            [name]: value,
        };
        setForm(newForm);
        doValidate(newForm);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!expertData) {
            await checkAccountConfirmationToken({ token, captcha });
        }

        if (!doValidate(form) || !expertData) return;

        // setProcessing(true);
        // const result = await sendRegistrationVerificationCode(new SendVerificationCode({
        //     phone: expertData.phone,
        //     captcha,
        // }));
        //
        // setProcessing(false);
        setCaptcha('');

        //if (result) {
        nextStep(form.password);
        //}
    };

    return (
        <Col className="auth-forms--container">
            <form onSubmit={handleSubmit}>
                <Card
                  title="Регистрация"
                  ftTextCenter
                  apiError={apiError}
                  legend={!(apiError && apiError.failures && apiError.failures.token) ? (
                    <LoaderBtn
                      variant="primary"
                      type="submit"
                      disabled={processing}
                      loading={processing}
                    >
                        {expertData ? 'Зарегистрироваться' : 'Отправить'}
                    </LoaderBtn>
                ) : undefined}
                >
                    <div>
                        <div className={styles.sub_title}>
                            в автоматизированной системе проведения аккредитаций<br />
                            Национальной Медицинской Палаты
                        </div>

                        {expertData && (
                            <>
                                <FormGroup data-test-last-name-group>
                                    <FormLabel>Фамилия</FormLabel>
                                    <FormControl
                                      autoFocus
                                      name="lastName"
                                      value={expertData.lastName}
                                      disabled
                                    />
                                </FormGroup>

                                <FormGroup data-test-first-name-group>
                                    <FormLabel>Имя</FormLabel>
                                    <FormControl
                                      name="firstName"
                                      value={expertData.firstName}
                                      disabled
                                    />
                                </FormGroup>

                                <FormGroup data-test-middle-name-group>
                                    <FormLabel>Отчество</FormLabel>
                                    <FormControl
                                      name="middleName"
                                      value={expertData.middleName}
                                      disabled
                                    />
                                </FormGroup>

                                <PhoneInput
                                  labelTitle="Мобильный телефон"
                                  labelColSize={12}
                                  inputColSize={12}
                                  inputClassNames="p-0"
                                  value={expertData.phone}
                                  onChange={() => true}
                                  disabled
                                />

                                <FormGroup data-test-password-group>
                                    <FormLabel>Придумайте пароль</FormLabel>
                                    <InputPassword
                                      name="password"
                                      onChange={handleChange}
                                      isInvalid={!!errors.password}
                                      value={form.password}
                                    />

                                    {!!errors.password && (
                                        <div className={styles.input_error_block}>
                                            Пароль должен быть от 6-ти до 15-ти символов, можно использовать только
                                            цифры, символы или латиницу
                                        </div>
                                    )}
                                </FormGroup>
                            </>
                        )}
                        <Captcha captcha={captcha} captchaValid={captchaValid} apiError={apiError} setCaptcha={setCaptcha} />
                    </div>
                    <Form.Control.Feedback className="d-block" type="invalid">
                        {apiError && ((apiError.failures && !(apiError.failures.lastName || apiError.failures.firstName || apiError.failures.middleName || apiError.failures.phone || apiError.failures.password)) || (apiError.type === 'captcha')) && apiError.message}
                    </Form.Control.Feedback>
                </Card>
            </form>
        </Col>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    sendRegistrationVerificationCode: dispatch.auth.sendRegistrationVerificationCodeAsync,
    checkAccountConfirmationToken: dispatch.auth.checkAccountConfirmationTokenAsync,
});

export default connect(mapState, mapDispatch)(Step1);

type connectedProps = ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>
type Props = connectedProps & OwnProps;

interface OwnProps {
    token: string;
    expertData: IExpertConfirmationData | null;
    nextStep: (password: string) => void;
}

interface IState {
    password: string;
    captcha: string;
    token: string;
}
